import { render, staticRenderFns } from "./statusTabs.vue?vue&type=template&id=26bfec63&"
import script from "./statusTabs.vue?vue&type=script&lang=js&"
export * from "./statusTabs.vue?vue&type=script&lang=js&"
import style0 from "./statusTabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports